import React, { useState } from "react";
import AirportInformation from "./AirportInformation";
import AirportTraffic from "./AirportTraffic";

function SelectInformation({AirportSelection}) {
    const [button1Color, setButton1Color] = useState('white');
    const [button2Color, setButton2Color] = useState('white');
    const [selectedButton, setselectedButton] = useState("");

    const handleButton1Click = () => {
        setButton1Color("rgb(0, 102, 255)");
        setButton2Color('white')
        setselectedButton("Button1");
      };
      
    
      const handleButton2Click = () => {
        setButton2Color("rgb(0, 102, 255)");
        setButton1Color('white')
        setselectedButton("Button2");
      };
    

  return(
        <div>
            <div style = {{display: "flex", marginTop: "5%", marginBottom: "5%"}}>
                <button type="button" className="btn btn-outline-secondary" style={{ backgroundColor: button1Color, marginRight: "0px", borderBottom: "2px solid black", borderWidth: "0 0 2px 0", color: "black"}} onClick={handleButton1Click} >
                    Πληροφορίες αεροδρομίου
                </button>
                <button type="button" className="btn btn-outline-secondary" style={{ backgroundColor: button2Color, borderLeft: "2px solid black", borderTop: "2px solid black", borderRight: "2px solid black", borderWidth: "2px 0 0 2px", color: "black"}} onClick={handleButton2Click}>
                    Επιβατική Κίνηση
                </button>    
            </div>
            {/* <hr style = {{borderColor: "#b3e6ff"}}></hr> */}
            {selectedButton === ("Button1")? <AirportInformation AirportSelection = {AirportSelection}></AirportInformation>:  selectedButton === ("Button2") ? <AirportTraffic AirportSelection = {AirportSelection}></AirportTraffic>:<></>}
        </div>
        
        
  );
}

export default SelectInformation;
